export function round(num, inc) {
    return Math.round(Math.round(num / (inc / 10)) / 10) * inc; // https://gordonlesti.com/inaccurate-rounding-with-decimal-digits/
}

export function truncateZeros(num) {
    const hasZeros = `${num}`.search(/.(\d)+0{3}/) > -1;
    if (hasZeros) {
        const indexOfZeros = `${num}`.search(/0{3}/);
        return `${num}`.slice(0, indexOfZeros);
    }
    return `${num}`;
}



// WEBPACK FOOTER //
// ./src/util/number.js